import { GridBreakpoints } from './grid.types';

type WithRequired<T, K extends keyof T> = T & { [P in K]-?: T[P] };

export function isGridBreakpoint<T>(x?: T | GridBreakpoints<T>): x is GridBreakpoints<T> {
  return x !== undefined && typeof (x as GridBreakpoints<T>) === 'object';
}
export function isGridDefBreakpoint<T>(x?: T | GridBreakpoints<T>): x is WithRequired<GridBreakpoints<T>, 'def'> {
  return isGridBreakpoint(x) && x.def !== undefined;
}

export function isGridSmBreakpoint<T>(x?: T | GridBreakpoints<T>): x is WithRequired<GridBreakpoints<T>, 'sm'> {
  return isGridBreakpoint(x) && x.sm !== undefined;
}

export function isGridMdBreakpoint<T>(x?: T | GridBreakpoints<T>): x is WithRequired<GridBreakpoints<T>, 'md'> {
  return isGridBreakpoint(x) && x.md !== undefined;
}

export function isGridLgBreakpoint<T>(x?: T | GridBreakpoints<T>): x is WithRequired<GridBreakpoints<T>, 'lg'> {
  return isGridBreakpoint(x) && x.lg !== undefined;
}

export function isGridXlBreakpoint<T>(x?: T | GridBreakpoints<T>): x is WithRequired<GridBreakpoints<T>, 'xl'> {
  return isGridBreakpoint(x) && x.xl !== undefined;
}

export function isGrid2xlBreakpoint<T>(x?: T | GridBreakpoints<T>): x is WithRequired<GridBreakpoints<T>, '2xl'> {
  return isGridBreakpoint(x) && x['2xl'] !== undefined;
}
